import { dictonary } from './dictonary';
export function validateInput(inputValues, checkFields) {
  var errors = {};

  if (checkFields) {
    checkFields.forEach(function (el) {
      var _dictonary$error = dictonary.error,
          EMPTY = _dictonary$error.EMPTY,
          PASSWORD = _dictonary$error.PASSWORD,
          RETRY = _dictonary$error.RETRY;

      if (inputValues) {
        if (!inputValues[el]) {
          errors[el] = EMPTY;
        }

        if (el === 'password' || el === 'passwordRetry') {
          if (inputValues[el] && inputValues[el].length < 6) {
            errors[el] = PASSWORD;
          }
        }

        if (el === 'passwordRetry') {
          if (inputValues['password'] !== inputValues[el]) {
            errors[el] = RETRY;
          }
        }
      }
    });
  }

  return errors;
}